import { DEFAULT_COVER_IMG, DEFAULT_TITLE } from '@/common/components/HeadMetaTags/HeadMetaTags';
import { PageConfig, RouteBuilder, RouteOptions } from '@/common/routes/RouteBuilder';

export interface SearchParams {
  phrase: string;
}
interface SearchOptions extends SearchParams, RouteOptions {}

// TODO: remove WIP from name. There are already links to sr-artworks as search page in external links. Remove them first, and then remove WIP from name.
export const RouteToSearchPageWIP = (options: SearchOptions) => {
  return RouteBuilder({
    path: `/search/${options.phrase}`,
    target: 'elysium',
    ...options,
  });
};

export const SearchPageConfig: PageConfig = {
  readableName: 'Search Results Page',
  analyticsGaName: 'search', // TODO: this is temp value for template
  analyticsAthenaName: 'search', // TODO: this is temp value for template
  pagePathnames: ['/search/[phrase]'], // TODO: this is temp value for template
  displayPromoBar: false,
  defaultMeta: {
    title: DEFAULT_TITLE,
    description: 'TEMP DESCRIPTION', // TODO: this is temp value for template
    coverImage: DEFAULT_COVER_IMG,
  },
};
